// extracted by mini-css-extract-plugin
export default {"imageCard":"ImageGallery_imageCard__QXnfb"};